import * as React from 'react';

interface HeaderBodyContainerProps {
    children?: React.ReactNode;
    containerClassName?: string;
    bodyClassName?: string;
    header?: React.ReactNode;
}

const HeaderBodyContainer = (props: HeaderBodyContainerProps): JSX.Element => {
    const { containerClassName, bodyClassName, children, header } = props;

    return <div className={`${containerClassName || ''}`}>
        { header }
        <div className={bodyClassName}>
            {children}
        </div>
    </div>;
};

export { HeaderBodyContainer };
export default HeaderBodyContainer;